import {Helper, Schema, FieldSet, SchemaResult} from 'simpli-web-sdk'
import {NotasInseridas} from '@/model/resource/NotasInseridas'

export class CsvNotasInseridasSchema extends Schema {
  readonly name = 'CsvNotasInseridas'

  populatedMonths: Array<boolean> | null = null

  constructor(months?: Array<boolean>) {
    super()
    this.populatedMonths = months || null
  }

  readonly fieldSet: FieldSet<NotasInseridas> = {
    nomeFantasia: schema =>
      schema.model.responsavel && schema.model.responsavel.nomeFantasia
        ? schema.model.responsavel.nomeFantasia
        : schema.model.responsavel?.razaoSocial ?? '-',
    janeiro: schema => this.getAmountByMonth(schema, 1),
    fevereiro: schema => this.getAmountByMonth(schema, 2),
    marco: schema => this.getAmountByMonth(schema, 3),
    abril: schema => this.getAmountByMonth(schema, 4),
    maio: schema => this.getAmountByMonth(schema, 5),
    junho: schema => this.getAmountByMonth(schema, 6),
    julho: schema => this.getAmountByMonth(schema, 7),
    agosto: schema => this.getAmountByMonth(schema, 8),
    setembro: schema => this.getAmountByMonth(schema, 9),
    outubro: schema => this.getAmountByMonth(schema, 10),
    novembro: schema => this.getAmountByMonth(schema, 11),
    dezembro: schema => this.getAmountByMonth(schema, 12),
  }

  private getAmountByMonth(
    schema: SchemaResult<NotasInseridas>,
    month: number
  ) {
    return (
      schema.model.qtdNotasMes?.find(nota => nota.mes == month)?.qtdNota ||
      (this.populatedMonths && this.populatedMonths[month - 1] ? 0 : '')
    )
  }
}
